import * as React from 'react'

function SvgIconTel(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#icon_tel_svg__clip0)" fill="#fff">
        <path d="M18.5 10.41a4 4 0 01-4-3.44.26.26 0 00-.23-.22 44.498 44.498 0 00-4.62 0 .26.26 0 00-.19.25 4 4 0 01-4 3.44H4.25a.25.25 0 00-.25.25v7.75a2.5 2.5 0 002.5 2.5h11a2.5 2.5 0 002.5-2.5v-7.78a.25.25 0 00-.25-.25H18.5zM12 16a1 1 0 110 2 1 1 0 010-2zm-1-3a1 1 0 112 0 1 1 0 01-2 0zm3 4a1 1 0 112 0 1 1 0 01-2 0zm2-4a1 1 0 11-2 0 1 1 0 012 0zm-7-1a1 1 0 110 2 1 1 0 010-2zm0 4a1 1 0 110 2 1 1 0 010-2z" />
        <path d="M21.1.92a45.34 45.34 0 00-18.2 0A3.71 3.71 0 000 4.41v2a2.5 2.5 0 002.5 2.5h3A2.5 2.5 0 008 6.41V5.6a.25.25 0 01.23-.25 45.2 45.2 0 017.54 0 .25.25 0 01.23.25v.81a2.5 2.5 0 002.5 2.5h3a2.5 2.5 0 002.5-2.5v-2A3.71 3.71 0 0021.1.92z" />
      </g>
      <defs>
        <clipPath id="icon_tel_svg__clip0">
          <path fill="#fff" d="M0 0h24v20.91H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SvgIconTel
